/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendVentureEnumsResponseDto } from '../models/backend-venture-enums-response-dto';
import { BackendVentureFundDto } from '../models/backend-venture-fund-dto';
import { ventureFundsVentureFundsCopyCreate } from '../fn/venture-fund/venture-funds-venture-funds-copy-create';
import { VentureFundsVentureFundsCopyCreate$Params } from '../fn/venture-fund/venture-funds-venture-funds-copy-create';
import { ventureFundsVentureFundsCreate } from '../fn/venture-fund/venture-funds-venture-funds-create';
import { ventureFundsVentureFundsCreate$FormData } from '../fn/venture-fund/venture-funds-venture-funds-create-form-data';
import { VentureFundsVentureFundsCreate$FormData$Params } from '../fn/venture-fund/venture-funds-venture-funds-create-form-data';
import { VentureFundsVentureFundsCreate$Params } from '../fn/venture-fund/venture-funds-venture-funds-create';
import { ventureFundsVentureFundsCreate$XWwwFormUrlencoded } from '../fn/venture-fund/venture-funds-venture-funds-create-x-www-form-urlencoded';
import { VentureFundsVentureFundsCreate$XWwwFormUrlencoded$Params } from '../fn/venture-fund/venture-funds-venture-funds-create-x-www-form-urlencoded';
import { ventureFundsVentureFundsDestroy } from '../fn/venture-fund/venture-funds-venture-funds-destroy';
import { VentureFundsVentureFundsDestroy$Params } from '../fn/venture-fund/venture-funds-venture-funds-destroy';
import { ventureFundsVentureFundsEnumsRetrieve } from '../fn/venture-fund/venture-funds-venture-funds-enums-retrieve';
import { VentureFundsVentureFundsEnumsRetrieve$Params } from '../fn/venture-fund/venture-funds-venture-funds-enums-retrieve';
import { ventureFundsVentureFundsPartialUpdate } from '../fn/venture-fund/venture-funds-venture-funds-partial-update';
import { ventureFundsVentureFundsPartialUpdate$FormData } from '../fn/venture-fund/venture-funds-venture-funds-partial-update-form-data';
import { VentureFundsVentureFundsPartialUpdate$FormData$Params } from '../fn/venture-fund/venture-funds-venture-funds-partial-update-form-data';
import { VentureFundsVentureFundsPartialUpdate$Params } from '../fn/venture-fund/venture-funds-venture-funds-partial-update';
import { ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded } from '../fn/venture-fund/venture-funds-venture-funds-partial-update-x-www-form-urlencoded';
import { VentureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund/venture-funds-venture-funds-partial-update-x-www-form-urlencoded';
import { ventureFundsVentureFundsUpdate } from '../fn/venture-fund/venture-funds-venture-funds-update';
import { ventureFundsVentureFundsUpdate$FormData } from '../fn/venture-fund/venture-funds-venture-funds-update-form-data';
import { VentureFundsVentureFundsUpdate$FormData$Params } from '../fn/venture-fund/venture-funds-venture-funds-update-form-data';
import { VentureFundsVentureFundsUpdate$Params } from '../fn/venture-fund/venture-funds-venture-funds-update';
import { ventureFundsVentureFundsUpdate$XWwwFormUrlencoded } from '../fn/venture-fund/venture-funds-venture-funds-update-x-www-form-urlencoded';
import { VentureFundsVentureFundsUpdate$XWwwFormUrlencoded$Params } from '../fn/venture-fund/venture-funds-venture-funds-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiVentureFundService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ventureFundsVentureFundsCreate()` */
  static readonly VentureFundsVentureFundsCreatePath = '/api/venture_funds/venture-funds/';

  /**
   * Создать венчурный фонд.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundsCreate$Response(
    params: VentureFundsVentureFundsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать венчурный фонд.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundsCreate(
    params: VentureFundsVentureFundsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /**
   * Создать венчурный фонд.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundsCreate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать венчурный фонд.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundsCreate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /**
   * Создать венчурный фонд.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundsCreate$FormData$Response(
    params: VentureFundsVentureFundsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Создать венчурный фонд.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundsCreate$FormData(
    params: VentureFundsVentureFundsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundsEnumsRetrieve()` */
  static readonly VentureFundsVentureFundsEnumsRetrievePath = '/api/venture_funds/venture-funds-enums/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundsEnumsRetrieve$Response(
    params?: VentureFundsVentureFundsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureEnumsResponseDto>> {
    return ventureFundsVentureFundsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundsEnumsRetrieve(
    params?: VentureFundsVentureFundsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendVentureEnumsResponseDto> {
    return this.ventureFundsVentureFundsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureEnumsResponseDto>): BackendVentureEnumsResponseDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundsUpdate()` */
  static readonly VentureFundsVentureFundsUpdatePath = '/api/venture_funds/venture-funds/{id}/';

  /**
   * Обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundsUpdate$Response(
    params: VentureFundsVentureFundsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundsUpdate(
    params: VentureFundsVentureFundsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /**
   * Обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundsUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundsUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /**
   * Обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundsUpdate$FormData$Response(
    params: VentureFundsVentureFundsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundsUpdate$FormData(
    params: VentureFundsVentureFundsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundsDestroy()` */
  static readonly VentureFundsVentureFundsDestroyPath = '/api/venture_funds/venture-funds/{id}/';

  /**
   * Удалить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundsDestroy$Response(
    params: VentureFundsVentureFundsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return ventureFundsVentureFundsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundsDestroy(
    params: VentureFundsVentureFundsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.ventureFundsVentureFundsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundsPartialUpdate()` */
  static readonly VentureFundsVentureFundsPartialUpdatePath = '/api/venture_funds/venture-funds/{id}/';

  /**
   * Частично обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundsPartialUpdate$Response(
    params: VentureFundsVentureFundsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ventureFundsVentureFundsPartialUpdate(
    params: VentureFundsVentureFundsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /**
   * Частично обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Response(
    params: VentureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded(
    params: VentureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /**
   * Частично обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundsPartialUpdate$FormData$Response(
    params: VentureFundsVentureFundsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Частично обновить венчурный фонд.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ventureFundsVentureFundsPartialUpdate$FormData(
    params: VentureFundsVentureFundsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }

  /** Path part for operation `ventureFundsVentureFundsCopyCreate()` */
  static readonly VentureFundsVentureFundsCopyCreatePath = '/api/venture_funds/venture-funds/{id}/copy/';

  /**
   * Скопировать венчурный фонд.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ventureFundsVentureFundsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundsCopyCreate$Response(
    params: VentureFundsVentureFundsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVentureFundDto>> {
    return ventureFundsVentureFundsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Скопировать венчурный фонд.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ventureFundsVentureFundsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ventureFundsVentureFundsCopyCreate(
    params: VentureFundsVentureFundsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendVentureFundDto> {
    return this.ventureFundsVentureFundsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVentureFundDto>): BackendVentureFundDto => r.body),
    );
  }
}
